// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4588":"f1b051c1","6145":"86e385cb"}[chunkId] + ".chunk.css";
};